import type { ReactNode } from 'react';
import React from 'react';

export type SplitViewHeaderProps = {
  children: ReactNode;
  actionButtons?: JSX.Element[];
};

export function SplitViewHeader({
  children,
  actionButtons
}: SplitViewHeaderProps) {
  return (
    <div className="pAsm dF aiC jcSB">
      <div className="dIF">{children}</div>
      <div className="dF">{withSpacingBetween(actionButtons || [])}</div>
    </div>
  );
}
function withSpacingBetween(actionButtons: JSX.Element[]): ReactNode {
  return actionButtons.map(actionButton => (
    <div className="mHs">{actionButton}</div>
  ));
}
